<template>
  <div class="home">
    <Hero />

    <Values />

    <Champions />
    <Portfolio />
    <div v-if="false">
      <Contact />
    </div>
    <MiniTachi15 />

    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import Hero from "@/components/Hero.vue";
import Values from "@/components/Values.vue";
import Champions from "@/components/Champions.vue";
import Portfolio from "@/components/Portfolio.vue";
import Contact from "@/components/Contact.vue";
import MiniTachi15 from "@/components/MiniTachi15.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "home",
  components: {
    Hero,
    Values,
    Champions,
    Contact,
    Portfolio,
    Footer,
    MiniTachi15
  }
};
</script>
